module.exports = __webpack_public_path__ + "static/img/release-font.e1e600e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/release-font.png
// module id = fIAa
// module chunks = 36